<template>
    <tr>
        <td>
            {{ campaign.index + 1 }}
        </td>
        <td>
            <a :href="`/campaigns/${campaign.id}?model=archive`" target="_blank">
                {{ campaign.title }}
            </a>
        </td>
        <td>
            {{ campaign.author_id }}
        </td>
        <td>
            {{ campaign.email }}
        </td>
        <td>
            <a :href="campaign.project_url">
                link
            </a>
        </td>
        <td>
            {{ addedDate }}
        </td>
    </tr>
</template>

<script>
import moment from 'moment'
import {updateData} from "../../../firebaseCRUD";
import {toggleFeatured} from "../../FeaturedCampaigns/featured.service";
import { message } from 'ant-design-vue'

export default {
    props: [
        'campaign'
    ],
    data: function () {
        return {
            hidden: this.campaign.hidden,
            isFeatured: this.campaign.featured,
        }
    },
    computed: {
        addedDate() {
            return moment.unix(this.campaign.created_at.seconds).format('DD/MM/YYYY')
        }
    },
}
</script>